import { useContext, useEffect, useState } from "react";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ColumnVisibilityMenu from "../../../../ui/ColumnVisibilityMenu";
import TableSearchInput from "../../../../ui/TableSearchInput";
import IconAsignarProceso from "../../../../ui/icons-seleccion/IconAsignarProceso";
import IconBloquear from "../../../../ui/icons-seleccion/IconBloquear";
import IconDescargaNomina from "../../../../ui/icons-seleccion/IconDescargaNomina";
import ModalAsignarProceso from "../../RegistroHabilitado/Modal/ModalAsignarProceso";
import FiltroGenerico from "../../../../ui/kit-modal/FiltroGenerico";
import InputFiltro from "../../../../ui/kit-modal/Filtros-kit/InputFiltro";
import StateFiltro from "../../../../ui/kit-modal/Filtros-kit/StateFiltro";
import ModalGenerico from "../../../../ui/kit-modal/ModalGenerico";
import ModalDescartarBloquear from "../../../../ui/kit-modal/bloquearDescartar/ModalDescartarBloquear";
import IconDescarte from "../../../../ui/icons-seleccion/IconDescarte";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ModalAvanzarProceso from "../../../../ui/kit-modal/avanzarProceso/ModalAvanzarProceso";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { downloadFichaLegacyByRuts } from "../../../../../services/fichaLegacyService";
import {
  IEstadosExcel,
  IFiltrosExcel,
} from "../../../../../interfaces/ISeleccion";
import IconCargando from "../../../../ui/icons-seleccion/IconCargando";
import ModalNoProcesadoSeleccion from "../../../../ui/kit-modal/noProcesado/ModalNoProcesadoSeleccion";
import IconSolicitarCandidato from "../../../../ui/icons-seleccion/IconSolicitarCandidato";
import ModalSolicitarRegistro from "../Modal/ModalSolicitarRegistro";
import BotonExcelMasterRex from "../../../../ui/excelMasterRex/BotonExcelMasterRex";
import { OPCIONES_FILTRO_CEDULA } from "../../../../../utils/filtroCedula";

interface IActionMasive {
  listadoSeleccionado: any;
  localStorageFilter: string;
  setFormFilter: Function;
  formFilter: any;
  handleAvanzarProceso: Function;
  candidates: any;
  setCandidates: Function;
  listRefresh: Function;
  setListadoSeleccionado: Function;
  solicitudes: any;
  setSolicitudes: Function;
  handleClickSolicitarCandidato: Function;
  columnDefinitions: readonly { key: string; label: string }[];
  visibleColumnKeys: string[];
  setVisibleColumnKeys: (keys: string[]) => void;
  isSavingColumns?: boolean;
  isColumnsSynchronized?: boolean | null;
  searchValue?: string;
  onSearch?: (term: string) => void;
}

const ActionMassive = (props: IActionMasive) => {
  const {
    listadoSeleccionado,
    localStorageFilter,
    setFormFilter,
    formFilter,
    handleAvanzarProceso,
    setCandidates,
    listRefresh,
    setListadoSeleccionado,
    solicitudes,
    setSolicitudes,
    handleClickSolicitarCandidato,
    columnDefinitions,
    visibleColumnKeys,
    setVisibleColumnKeys,
    isSavingColumns,
    isColumnsSynchronized,
    searchValue,
    onSearch,
  } = props;
  const {
    token,
    userId,
    listaCandidatoPendienteMasivo,
    getCandidatoPendienteMasivo,
    listaNoProcesadosSeleccion,
    postGenerarExcel,
  } = useContext(SeleccionContext);
  const [isOpenModalSolicitar, setIsOpenModalSolicitar] = useState<boolean>(false);
  const [rutSolicitar, setRutSolicitar] = useState<string[]>([]);
  const [candidatesSolicitar, setCandidatesSolicitar] = useState<any[]>([]);
  const [selectedProcesoDestino, setSelectedProcesoDestino] = useState<string | undefined>(undefined);
  const [selectedComentario, setSelectedComentario] = useState<string>("");
  const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
  const [isLoadingFicha, setIsLoadingFicha] = useState<boolean>(false);
  const handleDownloadFichas = async (): Promise<void> => {
    if (isLoadingFicha || !buttonEnabled) return;
    setIsLoadingFicha(true);
    try {
      const candidates = (listaCandidatoPendienteMasivo || [])
        .filter((item: any) => listadoSeleccionado.includes(item.personaDNI))
        .map((item: any) => ({ rut: item.personaDNI, busquedaId: item.busquedaId, busPerId: item.busPerId }));
      await downloadFichaLegacyByRuts(candidates);
    } catch (error) {
      console.log("ERROR DESCARGANDO FICHAS", error);
    } finally {
      setIsLoadingFicha(false);
    }
  };
  const [isOpenModalBloquear, setIsOpenModalBloquear] =
    useState<boolean>(false);
  const [isOpenModalDescartar, setIsOpenModalDescartar] =
    useState<boolean>(false);
  const [isOpenModalAvanzar, setIsOpenModalAvanzar] = useState<boolean>(false);
  const [isOpenModalNoProcesado, setIsOpenModalNoProcesado] =
    useState<boolean>(false);
  const [isOpenModalAsignarProceso, setIsOpenModalAsignarProceso] =
    useState<boolean>(false);
  const [openModalFiltro, setOpenModalFiltro] = useState<boolean>(false);
  const [dataObject, setDataObject] = useState<boolean | undefined>(undefined);
  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean | undefined>(
    undefined
  );
  const estadosExcel: IEstadosExcel = {
    porValidar: true,
    preseleccionado: false,
    validado: false,
  };
  let filtrosExcel: IFiltrosExcel = {
    busPerIdList: [],
    reclutador: [],
    estadoRegistro: [],
    nombre: [],
    rut: [],
    proceso: [],
    cliente: [],
    tipoProceso: ["MASIVO"],
    fechaPostulacion: [],
    fechaValidacion: [],
    fechaPreseleccion: [],
    confirmaEntrevista: null,
    transporteTeamwork: null,
    entrevistaRealizada: null,
  };

  useEffect(() => {
    setButtonEnabled(listadoSeleccionado.length > 0);
  }, [listadoSeleccionado]);

  useEffect(() => {
    if (localStorage.getItem(localStorageFilter)) {
      const copyStorage: any = localStorage.getItem(localStorageFilter);
      const dataObject = Object.values(JSON.parse(copyStorage)).some(
        (value: any) => value.length > 0
      );
      setDataObject(dataObject);
    }
  }, [localStorage.getItem(localStorageFilter)]);

  const handleClickAsignarProceso = (): void => {
    setIsOpenModalAsignarProceso(true);
  };

  const handleClickBloquearCandidato = (): void => {
    setIsOpenModalBloquear(true);
  };

  const handleClickDescartarCandidato = (): void => {
    setIsOpenModalDescartar(true);
  };

  const handleClickAvanzarProceso = (): void => {
    setIsOpenModalAvanzar(true);
  };

  const handleAvanzarCandidate = (): void => {
    handleAvanzarProceso({ setIsOpenModalNoProcesado });
    setIsOpenModalAvanzar(false);
    const body = document.querySelector("body");
    if (body) {
      body.style.overflowY = "auto";
    }
    if (token) {
      listRefresh();
      setListadoSeleccionado([]);
    }
  };

  const handleClickNomina = async (): Promise<void> => {
    if (token) {
      if (localStorage.getItem(localStorageFilter)) {
        const copyStorage: any = localStorage.getItem(localStorageFilter);
        const dataObject = JSON.parse(copyStorage);
        filtrosExcel.proceso = dataObject.proceso?.map((valor: any) => parseInt(valor)) ?? [];
        filtrosExcel.cliente = [...dataObject.cliente];
        filtrosExcel.fechaPostulacion = [...dataObject.fechaPostulacion];
        filtrosExcel.reclutador = [...dataObject.reclutador];
        filtrosExcel.rut = [...dataObject.rut];
        filtrosExcel.nombre = [...dataObject.nombre];
      }
      filtrosExcel.busPerIdList = listadoSeleccionado.length > 0
        ? (listaCandidatoPendienteMasivo || [])
            .filter((item: any) => listadoSeleccionado.includes(item.personaDNI))
            .map((item: any) => item.busPerId)
            .filter(Boolean)
        : [];
      await postGenerarExcel({
        token,
        estadosExcel,
        filtrosExcel,
        setIsLoading: setIsLoadingExcel,
      });
    }
  };

  return (
    <>
      <section className="container-actions w-100">
        <div className="content-button-masive">
          <button
            className={`button-navegation ${
              buttonEnabled ? "naranjo" : "disabled"
            }`}
            onClick={() => handleClickAvanzarProceso()}
            disabled={buttonEnabled ? false : true}
          >
            Avanzar Candidato
            <ArrowForwardIcon />
          </button>
        </div>

        {onSearch && (
          <div
            style={{
              flex: "1 1 auto",
              minWidth: 0,
              display: "flex",
              margin: "0 16px",
            }}
          >
            <TableSearchInput
              value={searchValue ?? ""}
              onSearch={onSearch}
              placeholder="Buscar en la tabla…"
              height={40}
            />
          </div>
        )}

        <div className="content-actions-masive">
          <BotonExcelMasterRex
            listadoSeleccionado={listadoSeleccionado}
            estadosExcel={estadosExcel}
            filtrosExcel={filtrosExcel}
            localStorageFilter={localStorageFilter}
          />

          <Tooltip text="Asignar Proceso">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-reasignar" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleClickAsignarProceso}
            >
              <IconAsignarProceso fill={"#0065DD"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>
          <Tooltip text="Bloquear">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-block" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleClickBloquearCandidato}
            >
              <IconBloquear fill={"#BE2A2A"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>
          <Tooltip text="Descartar">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-block" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={handleClickDescartarCandidato}
            >
              <IconDescarte fill={"#BE2A2A"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>

          <Tooltip text={isLoadingFicha ? "Generando fichas…" : "Descargar Ficha"}>
            <button
              className={`button-actions ${
                buttonEnabled && !isLoadingFicha ? "active-rojo" : "disabled"
              }`}
              disabled={!buttonEnabled || isLoadingFicha}
              onClick={handleDownloadFichas}
            >
              {isLoadingFicha ? (
                <IconCargando fill="#D32F2F" />
              ) : (
                <PictureAsPdfIcon style={{ fontSize: 20 }} />
              )}
            </button>
          </Tooltip>

          <Tooltip text="Solicitar Candidato">
            <button
              className={`button-actions ${
                buttonEnabled ? "active-solicitar-candidato" : "disabled"
              }`}
              disabled={!buttonEnabled}
              onClick={() => {
                const filteredItems = (listaCandidatoPendienteMasivo || [])
                  .filter((item: any) => listadoSeleccionado.includes(item.personaDNI) && item.reclutadorId !== userId);
                setRutSolicitar(filteredItems.map((item: any) => item.personaDNI));
                setCandidatesSolicitar(filteredItems.map((item: any) => ({
                  busquedaId: item.busquedaId,
                  primerNombre: item.primerNombre,
                  primerApellido: item.primerApellido,
                  reclutador: item.reclutador,
                  fechaCreacion: item.fechaPostulacion,
                })));
                setSelectedProcesoDestino(undefined);
                setSelectedComentario("");
                setIsOpenModalSolicitar(true);
              }}
            >
              <IconSolicitarCandidato fill={"#E3A000"} disabled={!buttonEnabled} />
            </button>
          </Tooltip>

          <Tooltip text="Descargar Nómina">
            <button
              className={`button-actions ${
                isLoadingExcel ? "disabled file" : "active-file"
              }`}
              onClick={() => handleClickNomina()}
            >
              {isLoadingExcel ? (
                <IconCargando fill="#327a30" />
              ) : (
                <IconDescargaNomina fill="#327a30" />
              )}
            </button>
          </Tooltip>

          <ColumnVisibilityMenu
            variant="icon"
            columns={columnDefinitions as { key: string; label: string }[]}
            visibleKeys={visibleColumnKeys}
            onChange={setVisibleColumnKeys}
            isSaving={isSavingColumns}
            isSynchronized={isColumnsSynchronized}
          />

          <Tooltip text="Filtros">
            <button
              type="button"
              aria-label="Filtros"
              className="button-actions active-azul"
              onClick={() => setOpenModalFiltro((prev) => !prev)}
            >
              {dataObject ? (
                <FilterAltIcon style={{ fontSize: 24 }} />
              ) : (
                <FilterAltOutlinedIcon style={{ fontSize: 24 }} />
              )}
            </button>
          </Tooltip>
        </div>
      </section>

      {openModalFiltro && (
        <FiltroGenerico
          inline
          title="Filtros"
          localStorageFilter={localStorageFilter}
          onBack={() => setOpenModalFiltro(false)}
          onValueChange={setFormFilter}
          onPropertyChange={formFilter}
        >
          <div style={{ display: "none" }}>
          <StateFiltro
            layer="ESTADO"
            listState={["COMPLETO", "INCOMPLETO"]}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="estado"
          />
          </div>
          <InputFiltro
            layer="NOMBRE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="nombre"
          />
          <InputFiltro
            layer="RUT"
            typeFilter="rut"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="rut"
          />
          <InputFiltro
            layer="ID PROCESO"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="proceso"
          />
          <InputFiltro
            layer="CLIENTE"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="cliente"
          />
          <InputFiltro
            layer="FECHA POSTULACIÓN"
            typeFilter="date"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="fechaPostulacion"
          />
          <InputFiltro
            layer="RECLUTADOR"
            typeFilter="text"
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="reclutador"
          />
          {/* Estado de la validacion de cedula. Va ultimo porque es el mas
              nuevo y el menos usado: los filtros de siempre no se mueven. */}
          <StateFiltro
            layer="VALIDACIÓN"
            listState={OPCIONES_FILTRO_CEDULA}
            localStorageFilter={localStorageFilter}
            onValueChange={setFormFilter}
            onPropertyChange={formFilter}
            onPermaValues="cedula"
          />
        </FiltroGenerico>
      )}

      {isOpenModalAvanzar && (
        <ModalGenerico
          title="CONFIRMAR MOVIMIENTO"
          width="w-70"
          subtitle="Estás por mover de etapa a la siguiente selección: "
          onChangeBack={() => {
            setIsOpenModalAvanzar(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          onChangeGo={() => handleAvanzarCandidate()}
          buttonBackText="Cancelar"
          buttonGoText="Aceptar"
        >
          <ModalAvanzarProceso
            etapa="Validados"
            listCandidate={listadoSeleccionado}
            listData={listaCandidatoPendienteMasivo}
            setCandidates={setCandidates}
          />
        </ModalGenerico>
      )}

      {isOpenModalNoProcesado && (
        <ModalGenerico
          title="Candidatos No Enviados"
          iconTitle="danger"
          width="w-70"
          subtitle="Los siguiente candidatos no pudieron ser procesados:"
          onChangeBack={() => {
            setIsOpenModalNoProcesado(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
          buttonBackText="Cerrar"
        >
          <ModalNoProcesadoSeleccion list={listaNoProcesadosSeleccion ?? []} />
        </ModalGenerico>
      )}

      {isOpenModalAsignarProceso && (
        <ModalGenerico
          title="Asignar Proceso"
          width="w-70"
          subtitle="Selecciona Grupo y/o Proceso a asignar a la selección"
          onChangeBack={() => {
            setIsOpenModalAsignarProceso(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalAsignarProceso
            list={listadoSeleccionado}
            listSelect={listaCandidatoPendienteMasivo}
            getListRefresh={listRefresh}
            localStorageFilter={localStorageFilter}
            setListadoSeleccionado={setListadoSeleccionado}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalAsignarProceso(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
          />
        </ModalGenerico>
      )}

      {isOpenModalBloquear && (
        <ModalGenerico
          title="BLOQUEO DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por bloquear la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalBloquear(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="bloqueo"
            getListRefresh={listRefresh}
            setListadoSeleccionado={setListadoSeleccionado}
            listSelect={listaCandidatoPendienteMasivo ?? []}
            localStorageFilter={localStorageFilter}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalBloquear(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={listadoSeleccionado}
          />
        </ModalGenerico>
      )}

      {isOpenModalDescartar && (
        <ModalGenerico
          title="DESCARTE DE CANDIDATOS"
          width="w-70"
          subtitle="Estás por descartar la siguiente selección de candidatos:"
          onChangeBack={() => {
            setIsOpenModalDescartar(false);
            const body = document.querySelector("body");
            if (body) {
              body.style.overflowY = "auto";
            }
          }}
        >
          <ModalDescartarBloquear
            typeExclusion="descarte"
            getListRefresh={listRefresh}
            setListadoSeleccionado={setListadoSeleccionado}
            listSelect={listaCandidatoPendienteMasivo ?? []}
            localStorageFilter={localStorageFilter}
            formFilter={formFilter}
            onChangeBack={() => {
              setIsOpenModalDescartar(false);
              const body = document.querySelector("body");
              if (body) {
                body.style.overflowY = "auto";
              }
            }}
            list={listadoSeleccionado}
          />
        </ModalGenerico>
      )}

      {isOpenModalSolicitar && (
        <ModalGenerico
          width="w-90"
          title="SOLICITAR CANDIDATO"
          onChangeBack={() => {
            setIsOpenModalSolicitar(false);
            setRutSolicitar([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
          buttonBackText="Cerrar"
          buttonGoText="Solicitar"
          buttonGoStyle="confirm"
          buttonGoDisable={!!selectedProcesoDestino}
          onChangeGo={() => {
            handleClickSolicitarCandidato({ procesoDestino: selectedProcesoDestino, comentario: selectedComentario });
            setIsOpenModalSolicitar(false);
            setRutSolicitar([]);
            setSelectedProcesoDestino(undefined);
            setSelectedComentario("");
          }}
        >
          <ModalSolicitarRegistro
            rut={rutSolicitar}
            candidates={candidatesSolicitar}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            onChangeBack={() => {
              setIsOpenModalSolicitar(false);
              setRutSolicitar([]);
              setCandidatesSolicitar([]);
              setSelectedProcesoDestino(undefined);
              setSelectedComentario("");
            }}
            handleClickSolicitarCandidato={handleClickSolicitarCandidato}
            onSelectProceso={(value: string) => setSelectedProcesoDestino(value)}
            onComentario={(value: string) => setSelectedComentario(value)}
            masivo={true}
          />
        </ModalGenerico>
      )}
    </>
  );
};

export default ActionMassive;
